// extracted by mini-css-extract-plugin
module.exports = {"root":"Property_root__2QGuz","boxTitle":"Property_boxTitle__vNOLh","fields":"Property_fields__1YLtO","expandButton":"Property_expandButton__2k1mI"};